import { Box, Image, Text } from '@chakra-ui/react';
import React, { useState } from 'react';
import { WelcomeProps } from '../interfaces/components';
import WelcomeDesktop from '../assets/images/WelcomeDesktop.jpeg';
import WelcomeMobile from '../assets/images/WelcomeMobile.jpeg';
import EnterCTAVideo from '../assets/videos/EnterCTAVideo.webm';
import EnterCTAVideoAR from '../assets/videos/EnterCTAVideoAR.webm';
import StarryBG from '../assets/images/StarryBG.jpeg';
import useWindowDimensions from '../utils/hooks/useWindowDimensions';
import ReactPlayer from 'react-player';
import { WelcomeModal } from '../content';

const Welcome = ({ activeLocale, active, setActive }: WelcomeProps) => {
  const { width } = useWindowDimensions();
  const [showEnterButton, setShowEnterButton] = useState(true);

  const onClose = () => {
    setActive();
    setShowEnterButton(false);
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: 'startTagManager' });
  };

  return (
    <Box
      zIndex="10"
      opacity={active ? 1 : 0}
      visibility={active ? 'visible' : 'hidden'}
      transition="all 0.5s"
      position="fixed"
      top={0}
      right={0}
      left={0}
      bottom={0}
      margin="auto"
      bg="white"
      width="100%"
      height="100%"
    >
      <Image
        position="absolute"
        height="100vh"
        w="100%"
        src={width < 770 ? WelcomeMobile : WelcomeDesktop}
        objectFit="cover"
      />

      <Box
        width={['100%', '100%', '400px', '400px']}
        height={['120px', '130px', '160px', '170px']}
        position="absolute"
        top={['0px', '0px', '30px', '30px']}
        right={['0px', '0px', '30px', '30px']}
        bg="white"
        zIndex="53"
      >
        <Image
          position="absolute"
          height="100%"
          w="100%"
          src={StarryBG}
          objectFit="cover"
          padding={['10px']}
          zIndex="54"
        />
        <Box
          position="absolute"
          height="100%"
          w="100%"
          zIndex="55"
          padding={['20px']}
          display="flex"
          flexDirection="column"
          justifyContent="space-evenly"
          alignItems="center"
        >
          <Text
            fontSize={['13px', '15px', '17px', '20px']}
            fontFamily={activeLocale.includes('ar') ? 'GETwoLight' : 'RalewayMedium'}
            textAlign="center"
            color="white"
          >
            {activeLocale === undefined || !((activeLocale as keyof typeof WelcomeModal) in WelcomeModal)
              ? WelcomeModal['en'].topOne
              : WelcomeModal[activeLocale as keyof typeof WelcomeModal].topOne}
          </Text>
          <Text
            fontSize={['25px', '30px', '35px', '40px']}
            lineHeight={['25px', '30px', '35px', '40px']}
            fontFamily={activeLocale === 'ar' ? 'GETwoLight' : 'LoccitaneRegular'}
            textAlign="center"
            color="white"
          >
            {activeLocale === undefined || !((activeLocale as keyof typeof WelcomeModal) in WelcomeModal)
              ? WelcomeModal['en'].topTwo
              : WelcomeModal[activeLocale as keyof typeof WelcomeModal].topTwo}
          </Text>
        </Box>
      </Box>

      <Box
        opacity={showEnterButton ? 1 : 0}
        visibility={showEnterButton ? 'visible' : 'hidden'}
        transition="all 0.5s"
        position="absolute"
        left="0px"
        right="0px"
        bottom={['160px', '250px', '260px', '20%']}
        margin="auto"
        w={['80px', '90px', '120px', '140px']}
        textAlign="center"
        onClick={onClose}
        color="white"
        fontFamily={activeLocale.includes('ar') ? 'GETwoLight' : 'RalewayMedium'}
        cursor="pointer"
      >
        <ReactPlayer
          height="100%"
          width="100%"
          loop={true}
          muted
          controls={false}
          playing={true}
          url={activeLocale.includes('ar') ? EnterCTAVideoAR : EnterCTAVideo}
          playsinline
        />
      </Box>
    </Box>
  );
};
export default Welcome;
